/**
 * UI Configuration - Single Source of Truth
 *
 * This file contains all UI scaling configuration for fonts and spacing.
 * Both FontSizeContext and SpacingContext import from here.
 */

// Shared size type used by both font and spacing
export type UISize = 'compact' | 'standard' | 'comfortable';

// Order for cycling through sizes
export const uiSizeOrder: UISize[] = ['compact', 'standard', 'comfortable'];

/**
 * ROOT FONT SIZE
 * Controls the html font-size which scales all rem-based values in Tailwind.
 */
export const ROOT_FONT_SIZES: Record<UISize, number> = {
  compact: 13,      // Smaller text
  standard: 16,     // Default
  comfortable: 22,  // Larger text (was 24, adjusted for better UX)
};

/**
 * SPACING SCALE MULTIPLIER
 * Controls CSS variable --spacing-scale which scales padding/margins.
 */
export const SPACING_SCALES: Record<UISize, number> = {
  compact: 1.1,       // Tighter spacing
  standard: 1.3,   // Default
  comfortable: 1.8, // More breathing room
};

/**
 * LocalStorage keys for persisting user preferences
 */
export const STORAGE_KEYS = {
  fontSize: 'rainmaker-font-size',
  spacing: 'rainmaker-spacing',
} as const;

// Re-export for backwards compatibility
export type FontSize = UISize;
export type SpacingSize = UISize;
